/* eslint-disable @nx/enforce-module-boundaries */
import {
  CommentsIcon,
  DisagreeIcon,
  HandShakeSimpleIcon,
  DisableComment,
  DisabledAgreeDisagreeIcon,
} from '@mybridge/icons';
import { Button } from '@mybridge/ui/button';
import { HStack } from '@mybridge/ui/layout';
import { useContext, useEffect, useMemo, useState } from 'react';
import { PostCommentFormContext } from 'v4/components/comment/comment-form/context';
import { PostBoxContext } from '../context';
import { PostShareMenu } from '../post-share-menu';
import { Text } from '@mybridge/ui/text';
import { useSelector } from 'react-redux';
import { Tooltip } from '@mybridge/ui';
import { ForceSignInWrapper } from 'v4/components/force-sign-in-wrapper';
import { currentProfile } from 'v4/store/actions/user-profile.actions';
import { PostCommentAvatar } from '../post-actions-avatar';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { MyNetworkContext } from 'v4/components/network/context';
import { useRouter } from 'next/router';

export const PostBoxFooterActions = () => {
  const {
    commentBoxVisible,
    setCommentBoxVisible,
    handleLike,
    handleDislike,
    likeLoading,
    dislikeLoading,
    post: { liked_by, dislike_by, reply_control, can_agree, can_comment, id, ad_format, visibility, author } = {},
    commentsAllowed,
    handleAdClicksRouting,
    setupAdd,
    commentDisable,
    currentPostCommenter,
    refetch
  } = useContext(PostBoxContext);
  const { t } = useTranslator();
  const { campaignDetails } = useSelector(
    (state) => state.campaignReducer
  );
  const { textInputRef } = useContext(PostCommentFormContext);
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { loggedIn } = useSelector((state) => state.user);
  const commenterId = currentPostCommenter?.id || userProfileInfo?.id;
  const [likedByMe, setLikedByMe] = useState(liked_by&&liked_by?.find((lb) => lb?.id === commenterId));
  const [dislikedByMe, setDislikedByMe] = useState(dislike_by?.find((lb) => lb?.id === commenterId));
  
  // Update like/dislike states when currentPostCommenter or post data changes
  useEffect(() => {
    const commenterId = currentPostCommenter?.id || userProfileInfo?.id;
    setLikedByMe(liked_by&&liked_by?.find((lb) => lb?.id === commenterId));
    setDislikedByMe(dislike_by?.find((lb) => lb?.id === commenterId));
  }, [currentPostCommenter, liked_by, dislike_by, userProfileInfo?.id]);
  
  // Re-fetch post data when currentPostCommenter changes to ensure like/dislike states are up to date
  // useEffect(() => {
  //   if (currentPostCommenter) {
  //     refetch();
  //   }
  // }, [currentPostCommenter, refetch]);
  const router = useRouter();
  const isCampaignPage = router?.pathname?.includes('/campaign/setup/');

  const checkForText = () => {
    if (!can_agree && !can_comment) {
      return t('post.allOff') || 'Comments, Agree & Disagree are turned off on this post.';
    }
    return !can_agree
      ? t('post.agreeDisagreeOff') || 'Agree & Disagree are turned off on this post.'
      : !can_comment
      ? t('post.commentsOff') || 'Comments are turned off on this post.'
      : '';
  };
  const { companyPageDetail } = useSelector((state) => state.companyPage);
  const { currentProfileCommentData } = useSelector(
    (state) => state.userProfile
  );

  // useEffect(() => {
  //   if(companyPageDetail?.id)
  //     dispatch(currentProfile(companyPageDetail));
  // }, [companyPageDetail]);

const { isFriend } = useContext(MyNetworkContext);
  // const isEventPostVisible = useMemo(() => {
  //   if (visibility === 2 || visibility === 1) {
  //     return isFriend(author);
  //   }
  //   return true;
  // }, [visibility, author, isFriend]);

  // if (!isEventPostVisible) {
  //   return null; // Don't render the event post if it's not visible
  // }
  return (
    <ForceSignInWrapper>
      <HStack gap={0} px={0.5} py={1} >
        {loggedIn && (
          <HStack flex={1} justifyContent="center">
            <PostCommentAvatar
              companyDetails={campaignDetails?.page??currentPostCommenter}
              post={true}
            />
          </HStack>
        )}

        <HStack flex={1} justifyContent="center">
          <Tooltip
            label={
              commentDisable
                ? ''
                : commentsAllowed
                ? ''
                : t('scheduling.comments_disabled') || 'Comments disabled by author!'
            }
          >
            <Button
              w="100%"
              variant="ghost"
              borderRadius="full"
              leftIcon={<CommentsIcon />}
              onClick={(e) => {
                if(isCampaignPage) return;
                setCommentBoxVisible(!commentBoxVisible);
                handleAdClicksRouting('click', id);
                setTimeout(() => {
                  textInputRef?.current?.focus?.();
                }, 100);
              }}
              iconSpacing={[0, 0, 2]}
              isDisabled={!commentsAllowed || !can_comment}
            >
              <Text display={['none', 'none', 'block']}>{t('post.comment') || "Comment"}</Text>
            </Button>
          </Tooltip>
        </HStack>
        <HStack flex={1} justifyContent="center">
          <Button
            isLoading={likeLoading}
            onClick={()=> {
              if(isCampaignPage) return;
              handleLike();
            }}
            borderRadius="full"
            w="100%"
            isDisabled={!can_agree}
            variant="ghost"
            leftIcon={
              <HandShakeSimpleIcon
                height="20px"
                color={likedByMe ? '#037F29' : '#94B096'}
              />
            }
            iconSpacing={[0, 0, 2]}
          >
            <Text display={['none', 'none', 'block']}>
              {/* {likedByMe ? 'Agreed' : 'Agree'} */}
              {likedByMe ? t('post.agreed') || "Agreed" : t('post.agree') || "Agree"}
            </Text>
          </Button>
        </HStack>
        <HStack flex={1} justifyContent="center">
          <Button
            isLoading={dislikeLoading}
            borderRadius="full"
            w="100%"
            variant="ghost"
            onClick={()=>{
              if(isCampaignPage) return;
              handleDislike();
            }}
            isDisabled={!can_agree}
            leftIcon={
              <DisagreeIcon color={dislikedByMe ? '#E41C19' : '#B38C8C'} />
            }
            iconSpacing={[0, 0, 2]}
          >
            <Text display={['none', 'none', 'block']}>
              {/* {dislikedByMe ? 'Disagreed' : 'Disagree'} */}
              {dislikedByMe ? t('post.disagreed') || "Disagreed" : t('post.disagree') || "Disagree"}
            </Text>
          </Button>
        </HStack>
        {!ad_format && <PostShareMenu />}
      </HStack>
      {(!can_comment || !can_agree) && (
        <HStack
          px={4}
          py={1}
          borderTop="1px solid"
          borderColor="brandGray.500"
          bg="#E4E6EB"
        >
          <HStack flex={1} py={1}>
            {!can_comment && <DisableComment height="22" width="22" />}{' '}
            {!can_agree && <DisabledAgreeDisagreeIcon height="35px" />}{' '}
            {setupAdd ? (
              <Text>
                {t('otherModules.comments_turned_off') || "have been turned off on this post, You can still react or share it."}
              </Text>
            ) : (
              <Text fontSize="11px">{checkForText()}</Text>
            )}
          </HStack>
        </HStack>
      )}
    </ForceSignInWrapper>
  );
};
